import { createContext } from "react";

const geofencesContext = createContext();

export default geofencesContext;
